import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { SettingsService } from '@scaffold/services/settings.service';
import { PropertiesService } from '../../services/properties.service';
import { take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ScaffoldSidebarRef } from '@app/framework/sidebar/scaffold-sidebar.service';

@Component({
    selector: 'app-scaffold-options',
    templateUrl: './options.component.html',
    styleUrls: ['./options.component.css'],
    standalone: false
})
export class OptionsComponent implements OnInit, OnDestroy {
  comments_allowed = [
    'input',
    'select',
    'checkbox',
    'switch',
    'edit_text',
    'connection',
    'editor',
    'radio',
  ];
  model: string[];
  settings: any[];
  propertiesItem;
  disabled;
  hidden;
  tour = {};
  comments;
  fileSet: boolean;
  destroy$: Subject<boolean> = new Subject<boolean>();
  parentView: any;
  @Output() closeDialog = new EventEmitter<string>();
  @Output() optionsChange = new EventEmitter<string>();
  constructor(
    private settingsService: SettingsService,
    public properties: PropertiesService,
    private sidebarRef: ScaffoldSidebarRef
  ) {}

  optionsUpdate(e: string) {
    this.closeDialog.emit(e);
  }

  setPropertiesSelection(item) {
    this.properties.setProperties(item);
    if (!item) {
      this.sidebarRef.close();
    }
  }

  updateOptions(e) {
    console.log(e);
    this.properties.changeValue();
  }

  ngOnInit() {
    this.settingsService
      .getSettings()
      .pipe(take(1))
      .subscribe(settings => {
        this.settings = settings;
        this.disabled = {
          label: 'Input Disabled',
          param: 'disabled',
          type: 'checkbox',
        };
        this.hidden = {
          label: 'Hide in LMS',
          param: 'read_hidden',
          type: 'checkbox',
        };
        this.comments = {
          label: 'Allow Comments on Component',
          param: 'allow_comments',
          type: 'checkbox',
          help: '',
        };
        this.tour = {
          label: 'Tour',
          param: 'tour',
          type: 'settings_object',
          settings: [
            {
              label: 'Tour ID',
              param: 'tourId',
              type: 'text',
            },
            {
              label: 'Step ID',
              param: 'stepId',
              type: 'text',
            },
            {
              label: 'Position',
              param: 'tourPosition',
              type: 'text',
            },
          ],
        };
      });
    /*this.properties.watchProperties().pipe(takeUntil(this.destroy$)).subscribe(item => {
      this.parentView = this.properties.info;
      console.log(item);
      this.propertiesItem = item;
    });*/

    this.setFileSet();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  setTour() {
    this.tour = this.parentView.value[0].tour;
  }

  setFileSet() {
    if (this.parentView) {
      if (this.parentView.mode === 'view') {
        if (this.parentView.value && this.parentView.value.length > 0) {
          this.fileSet = this.parentView.value[0].file_data;
        }
      }
    }
  }
}
